module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_03_6DD79_1SE_GJ0.71e48170.png";